const P403 = () => {
  return (
    <div>
      <h1 className="grid place-content-center h-[80vh] text-Brown font-semibold ">
        403 | FORBIDDEN
      </h1>
    </div>
  );
};

export default P403;
